import React from 'react';
import { ControlledTextField } from 'components/TextField/ControlledTextField';
import styles from './AmountContainer.module.scss';
import { AmountContainerProps } from './types';
import { separateThousands, stripLeadingZero } from '../utils';

const AmountContainer: React.FC<AmountContainerProps> = ({
  name,
  currencySymbol,
  maxChars,
}) => {

  const normalizeAmountInput = (value: string) => {
    const normalizedValue = separateThousands(stripLeadingZero(value));
    return normalizedValue;
  };

  return (
    <div className={styles.container}>
      <div>
        <ControlledTextField
          name={name}
          placeholder="0"
          onlyNumbers
          maxChars={maxChars}
          normalize={normalizeAmountInput}
          prefix={currencySymbol}
          className={styles.textfield}
        />
      </div>
    </div>
  );
};

export default AmountContainer;
